import { Row } from 'reactstrap';
import { H4 } from '../../../AbstractElements';
import { ImageAbout } from '../../../Constant';
import PagesSort from './Pages';
import { DescriptionMyGallery } from '../../Gallery/GalleryGridWithDescription/DescriptionMyGallery';

const PhotosTab = () => {
  return (
    <>
      <div className='info-block m-t-30'>
        <H4 className='f-w-700 mb-2'>{ImageAbout}</H4>
        <Row className='my-gallery gallery-with-description'>
          <DescriptionMyGallery/>
        </Row>
      </div>
      <PagesSort pageClass="start" />
    </>
  );
};

export default PhotosTab;
